import { EntityWithId } from 'src/types'

export const ClienteTipoFields = {
    Descripcion: 'vchDescClienteTipo',
    Activo: 'bitActivo'
} as const

export type ClienteTipoDTO = EntityWithId & {
    [ClienteTipoFields.Descripcion]: string
    [ClienteTipoFields.Activo]: boolean
}

export const ClienteSubTipoFields = {
    Descripcion: 'vchDescClienteSubTipo',
    Activo: 'bitActivo'
} as const

export type ClienteSubTipoDTO = EntityWithId & {
    [ClienteSubTipoFields.Descripcion]: string
    [ClienteSubTipoFields.Activo]: boolean
}

export const RelacionFields = {
    Id: 'id',
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial',
    CodClienteTipo: 'codClienteTipo',
    DescripcionClienteTipo: 'descripcionClienteTipo',
    CodClienteSubTipo: 'codClienteSubTipo',
    DescripcionClienteSubTipo: 'descripcionClienteSubTipo',
    Activo: 'activo'
} as const

export type RelacionViewDTO = {
    [RelacionFields.Id]: number
    [RelacionFields.CodSectorComercial]: number
    [RelacionFields.NombreSectorComercial]: string
    [RelacionFields.CodClienteTipo]: number
    [RelacionFields.DescripcionClienteTipo]: string
    [RelacionFields.CodClienteSubTipo]: number
    [RelacionFields.DescripcionClienteSubTipo]: string
    [RelacionFields.Activo]: boolean
}

export type RelacionItemDTO = {
    codClienteTipo: number
    codClienteSubTipo: number
}
